import Bar from './hamburger-static.svg';

type BarProps = React.JSX.IntrinsicElements['div'] & {
  width?: string;
  alt?: string;
}

export const HamburgerBar = ({width = "30px", alt = "OnDeck", ...props}: BarProps) => <div {...props}><img src={Bar} width={width} alt={alt} /></div>
export default HamburgerBar;
